module.exports = __webpack_public_path__ + "static/Павлова ТВ-1_1.jpg";